import * as React from 'react';
import { Dispatch } from 'redux';
import { Button } from 'reactstrap';
import { GlobalPrivateState } from 'src/api';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ProjectModel } from 'franke-trough-dependencies';
import LoadingSpinner from 'src/app/Partials/LoadingSpinner/LoadingSpinner';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectsDelete.messages';

export interface ProjectDeleteProps {
  dispatch: Dispatch;
  project: RequestApiResult<ProjectModel>;
  projectId: string;
}

export interface ProjectDeleteState {
  redirect: boolean;
}

export class ProjectDeletePartial extends React.Component<ProjectDeleteProps, ProjectDeleteState> {
  constructor (props: ProjectDeleteProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      redirect: false,
    };
  }

  componentDidUpdate (prevProps: ProjectDeleteProps) {
    const project = this.project;
    const prevProject = prevProps.project.result;

    if ((project && project.updated_at) !== (prevProject && prevProject.updated_at)) {
      if (!this.state.redirect && project && project.deleted) {
        this.setState({
          redirect: true,
        });
      }
    }
  }

  public render() {
    return (
      <div className="page-project-delete d-flex justify-content-center align-items-center vh-100">
        {this.props.project.updating && !this.props.project.loaded && (
          <LoadingSpinner />
        )}
        {this.project && (
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h3 className="mb-5">
                  <FormattedMessage {...MESSAGES.projectsDeleteHeadline} />
                </h3>
                <Button
                  className="btn"
                  onClick={this.handleClick}
                >
                  <FormattedMessage {...MESSAGES.projectsDeleteButton} />
                </Button>
              </div>
            </div>
          </div>
        )}
        {this.state.redirect && (
          <Redirect to="/profile/projects" />
        )}
      </div>
    );
  }

  private get project(): ProjectModel & {deleted: boolean} | undefined {
    return this.props.project && this.props.project.result as ProjectModel & {deleted: boolean};
  }

  private dispatchRemove() {

    if (!this.project) {
      return;
    }

    const data: ProjectModel & {deleted: boolean} = this.project;
    data.deleted = true;
    this.props.dispatch(requestAPIActions.load(
      'project', {
        url: `/Projects/${this.project.id}`,
        options: {
          method: 'PATCH',
          data,
        },
      },
      true,
    ));
  }

  private handleClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    this.dispatchRemove();
  }
}

export const ProjectDelete = connect((state: GlobalPrivateState) => ({
  project: state.project,
}))(ProjectDeletePartial);

export default ProjectDelete;